import { heapIdentify, getPhoneAssignmentData, addToHeapEventAndUserProperties } from '../../helpers';

export function transformQuadlinkSuccessCallback(response, options = {}) {
	if (!response) {
		return;
	}

	for (const value in response) {
		if (window.modForm.opts.qsParams.includes(value) && response.hasOwnProperty(value)) { // eslint-disable-line no-prototype-builtins
			window.modForm.opts.quadLinkParams[value] = response[value];
		}
	}

	if (window.modForm.opts.phoneAssignmentConfig.showPhoneAssignmentNumber && !options.skipPhoneAssignmentCall) {
		getPhoneAssignmentData(response);
	}

	heapIdentify();
	window.modForm.opts.quadLinkHasBeenTransformed = true;
	addToHeapEventAndUserProperties([
		window.modForm.opts.quadLinkParams,
		{ 'AffiliateKey': response.AffiliateKey }
	]);
}
